import { render, staticRenderFns } from "./Pronto.vue?vue&type=template&id=b62996f0&scoped=true&"
import script from "./Pronto.vue?vue&type=script&lang=js&"
export * from "./Pronto.vue?vue&type=script&lang=js&"
import style0 from "./Pronto.vue?vue&type=style&index=0&id=b62996f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62996f0",
  null
  
)

export default component.exports